import licenseModule from '../../license.module';

export default licenseModule.component('licensePendingReceipt', {
    template: require('./licensePendingReceipt.component.html'),
    controller: [
        'LicenseManagementService',
        '$timeout',
        licensePendingReceiptComponent
    ],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licensePendingReceiptComponent(LicenseManagementService, $timeout) {
    var vm = this;
    vm.processing = false;

    vm.$onInit = function() {
        var navs = [
            {
                label: 'Receipt',
                value: 'receipt'
            }
        ];
        vm.nav = {
            options: {},
            items: navs,
            step: 0,
            selected: navs[0],
            selectedValue: function() {
                return this.selected.value;
            }
        };
        vm.data = vm.resolve.data;
        vm.input = {
            id: 'asuiTextareaReceipt',
            placeholder: 'Paste confirmation receipt here',
            rows: 10,
            options: {
                style: {}
            },
            validation: {
                required: true
            }
        };

        vm.asProgressSteps = {
            steps: [
                {
                    label: 'License Generated',
                    value: 1
                },
                {
                    label: 'License Applied',
                    value: 2
                },
                {
                    label: 'Apply Receipt',
                    value: 3
                }
            ],
            currentStep: 3,
            failed: false
        };
    };

    vm.cancel = function() {
        if (!vm.processing) {
            vm.dismiss({ $value: 'cancel' });
        }
    };

    vm.changes = function() {
        $timeout(function() {
            // Check beginning and ending of the receipt string format
            vm.substringBegin = vm.receipt
                .trim()
                .startsWith('----- BEGIN APPSPACE RECEIPT -----');
            vm.substringEnd = vm.receipt
                .trim()
                .endsWith('----- END APPSPACE RECEIPT -----');

            if (vm.substringBegin == true && vm.substringEnd == true) {
                vm.receiptError = false;
            } else {
                vm.receiptError = true;
            }
        });
    };

    vm.apply = function() {
        var payloadRequest = {
            payload: vm.receipt
        };

        if (!vm.processing) {
            vm.processing = true;
            setTimeout(function() {
                LicenseManagementService.applyReceipt(
                    vm.data.id,
                    payloadRequest
                ).then(
                    function() {
                        vm.receiptError = false;
                        vm.processing = false;
                        vm.close({ $value: vm.receipt });
                    },
                    function() {
                        vm.processing = false;
                        vm.receiptError = true;
                    }
                );
            }, 10000);
        }
    };

    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function(searchString, position) {
            var subjectString = this.toString();
            if (
                typeof position !== 'number' ||
                !isFinite(position) ||
                Math.floor(position) !== position ||
                position > subjectString.length
            ) {
                position = subjectString.length;
            }
            position -= searchString.length;
            var lastIndex = subjectString.lastIndexOf(searchString, position);
            return lastIndex !== -1 && lastIndex === position;
        };
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-pending-receipt/licensePendingReceipt.component.js